import { render, staticRenderFns } from "./EdeclarRecord.vue?vue&type=template&id=320a1835&scoped=true"
import script from "./EdeclarRecord.vue?vue&type=script&lang=js"
export * from "./EdeclarRecord.vue?vue&type=script&lang=js"
import style0 from "./EdeclarRecord.vue?vue&type=style&index=0&id=320a1835&prod&lang=css"
import style1 from "./EdeclarRecord.vue?vue&type=style&index=1&id=320a1835&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320a1835",
  null
  
)

export default component.exports